export default {
  'server': {
    'action': {
      'created': 'Đã tạo',
      'accepted': 'Chấp nhận',
    },
    'common': {
      'successed': 'Thành công',
      'error': 'Có Lỗi Xảy Ra',
      'existed-code': 'Mã đã tồn tại!',
      'wrong-action': 'Không đúng chức năng',
      'permission-denied': 'Bạn không có quyền truy cập',
      'invalid-duration': 'Khoảng thời gian không phù hợp',
      'invalid-expired-date': 'Ngày hết hạn không phù hợp',
      'request-processed': 'Yêu cầu này đã được duyệt hoặc bị huỷ',
      'wrong-password': 'Mật khẩu không chính xác',
      'reached-maximum-sms': 'Số lượng SMS đã vượt quá số lần được sử dụng',
      'send-email-failed': 'Gửi email thất bại, vui lòng thử lại sau',
      'not-found': 'Không tìm thấy thông tin',
      'invalid-data': 'Dữ liệu không đúng',
      'is-expired': 'Đã quá hạn',
      'reached-maximum': 'Vượt quá số lượng cho phép',
      'phone-existed': 'Số điện thoại đã tồn tại',
      'email-not-existed': 'Email không tồn tại',
      'wrong-email-format': 'Email không đúng định dạng',
      'incorrect-old-password': 'Mật khẩu cũ không chính xác'
    },
    'account': {
      'not-register': 'Bạn chưa đăng ký, vui lòng đăng ký',
      'not-actived': 'Tài khoản chưa được kích hoạt',
      'is-deleted': 'Tài khoản đã bị xóa',
      'already-exist': 'Tài khoản hoặc email đã tồn tại',
      'already-linked-google': 'Tài khoản google đã được liên kết với tài khoản khác',
      'already-linked-facebook': 'Tài khoản facebook đã được liên kết với tài khoản khác',
      'not-found-google': 'Không tìm thấy tài khoản được liên kết với tài khoản Google',
      'not-found-facebook': 'Không tìm thấy tài khoản được liên kết với tài khoản Facebook',
      'registered-google': 'Tài khoản google đã được đăng ký',
      'not-allow-customer': 'Khách hàng không thể đăng nhập',
      'entity-disabled': 'Tài khoản quản lý nhà cung cấp của bạn chưa được kích hoạt hoặc đã bị khóa',
      'required-report-role': 'Vui lòng đăng nhập với tài khoản người báo cáo',
      'confirm-reused-deleted': 'Tài khoản này đã bị xoá bạn có muốn khôi phục?',
    },
    'entity': {
      'is-disabled': 'Đối tượng đã bị vô hiệu hoá !',
      'already-in-supplier': 'Tài khoản đã có vai trò trong một Nhà Cung Cấp, bạn không thể tạo thêm',
      'cannot-delete-supplier': 'Không thể xoá nhà cung cấp đã tồn tại đại lý uỷ quyền',
      'forced-create': 'Đối tượng này đã bị xóa bạn có muốn khôi phục?',
      'not-under-subordinate-level': 'Đại lý này không thuộc cấp con của bạn',
      'reached-maximum-agent': 'Số lượng đại lý của bạn đã tối đa',
      'site-existing': 'Địa điểm sử dụng đã tồn tại trong vùng này',
      'supplier-email-already-used': 'Email nhà cung cấp đã được sử dụng bởi nhà cung cấp khác',
      'reached-maximum-user': 'Số lượng người dùng vượt quá cho phép',
    },
    'merchant': {
      'invalid-code': 'Mã đối tác không đúng',
    },
    'voucher': {
      'wrong-activation-code': 'Mã kích hoạt không đúng',
      'cannot-delete-distributed': 'Không thể xoá đợt phát hành đã phân phối voucher',
      'cannot-update-distributed': 'Không thể chỉnh sửa đợt phát hành đã phân phối voucher',
      'cannot-print-unpublished': 'Không thể in các voucher chưa xuất bản in',
      'reached-number-quantity': 'Số lượng voucher không được nhỏ hơn số lượng đã tạo là ',
      'been-issued': 'Voucher đã được phân phối',
      'is-invalid': 'Voucher này đã bị xoá hoặc vô hiệu hoá',
      'has-used': 'Voucher đã được sử dụng',
      'has-issued': 'Voucher đã phát hành',
      'is-disabled': 'Voucher đã vô hiệu hóa',
      'is-expired': 'Voucher đã hết hạn sử dụng',
      'invalid-usage-time': 'Voucher chưa tới ngày sử dụng',
      'cannot-used': 'Không thể sử dụng voucher này!',
      'undistributed': 'Voucher chưa được phân phối tới khách hàng',
      'not-exist-vouchers': 'Có những voucher không tồn tại trong hệ thống',
      'incorrect-activation-code': 'Mã kích hoạt không chính xác',
      'activion-code-unavaiable': 'Mã kích hoạt không tồn tại',
      'quantity-limited': 'Số lần sử dụng vượt quá giới hạn',
      'activion-code-expired': 'Mã kích hoạt đã hết hạn',
      'not-found': 'Không tìm thấy voucher',
      'issuance': {
        'not-existed': 'Đợt phát hành không tồn tại',
        'is-expired': 'Voucher này đã hết hạn được phân phối',
        'invalid-quantity': 'Số lượng cần phân phối vượt quá số lượng khả dụng',
        'confirm-create-with-existing': 'Đợt phát hành {prefix} - {suffix} đã tồn tại. Vui lòng chọn xác nhận nếu bạn muốn sử dụng đợt phát hành này?',
      },
      'transaction': {
        'cannot-transfer-yourself': 'Không thể chuyển cho chính bạn',
        'from-entity-not-exist': 'Đại lý chuyển đi không tồn tại',
        'to-entity-not-exist': 'Đại lý cần chuyển không tồn tại',
        'has-no-parent': 'Đối tượng không có cấp trên',
        'not-same-parent': 'Đại lý không cùng cấp cha',
        'not-own-voucher': 'Bạn không sở hữu voucher này',
        'out-of-available': 'Số lượng voucher voucher cần chuyển vượt quá số voucher hiện có',
        'exist-non-transferable': 'Tồn tại voucher không thể chuyển nhượng',
        'non-transferable': 'Voucher này không thể chuyển nhượng',
        'exist-used-vouchers': 'Tồn tại voucher đã được sử dụng',
        'is-used-voucher': 'Voucher này đã được sử dụng',
        'exist-confimation-vouchers': 'Tồn tại voucher đang chờ xác nhận sử dụng',
        'cannot-transfer-confirmation-voucher': 'Không thể chuyển voucher đang chờ xác nhận sử dụng',
        'exist-expired-vouchers': 'Tồn tại voucher đã hết hạn',
        'voucher-expired': 'Không thể chuyển nhượng voucher đã hết hạn',
        'is-expired-or-distributed': 'Voucher đã quá hạn hặc đã phân phối',
        'exist-unlocked-vouchers': 'Has vouchers which is not LOCKED USING state',
      },
      'approval': {
        'not-permission': 'Bạn không có quyền duyệt yêu cầu này',
        'request-cancelled': 'Yêu cầu này đã bị huỷ',
        'has-approved': 'Yêu cầu này đã được duyệt',
      },
      'reconciliation': {
        'cannot-process-approved': 'Không thể cập thông tin đối soát của Voucher đã đối soát',
        'was-approved': 'Voucher đối soát đã được phê duyệt',
        'not-found': 'Không tìm thấy voucher cần đối soát',
        'was-reconciled': 'Tồn tại voucher đã được tạo đối soát',
      },
      'promotion': {
        'not-existed': 'Mã voucher ưu đãi này không tồn tại',
        'has-expired': 'Voucher khuyến mãi này đã hết!',
        'out-of-usage-times': 'Quý khách đã hết số lần sử dụng',
        'code-not-existed': 'Mã khuyến mãi không tồn tại',
        'code-expired': 'Mã giảm giá hết hạn',
        'code-existed': 'Mã khuyến mãi đã tồn tại',
        'reached-usage-times': 'Promotion code has reached usage times',
      },
      'product': {
        'reach-maximum-quantity': 'Số lượng voucher cần mua vượt quá số lượng có sẵn',
        'reach-maximum-upload': 'Số lượng đưa lên portal vượt quá số lượng có sẵn',
        'reach-maximum-remove': 'Số lượng voucher cần gỡ vượt quá số lượng đã đưa lên',
        'active-key-existed': 'Mã kích hoạt đã tồn tại',
        'domain-existed': 'Tên miền đã tồn tại',
        'domain-in-used': 'Domain đã được sử dụng bởi đại lý khác',
        'verification-code-unavailable': 'Mã xác thực không tồn tại',
        'verification-code-expired': 'Mã xác thực đã quá hạn sử dụng',
        'agent-code-invalid': 'Mã đại lý không tồn tại',
        'email-domain-unavailable': 'Email domain không tồn tại',
        'incorrect-account': 'Tài khoản không chính xác',
        'catalog-code-existed': 'Mã danh mục đã tồn tại',
        'out-of-purchase': 'Bạn đã hết số lần được mua hàng cho sản phẩm này',
        'missing-activate-key': 'Mã kích hoạt là bắt buộc',
        'invalid-order-code': 'Không tìm thấy mã đơn hàng',
        'cart': {
          'over-quantity': 'Số lượng voucher muốn mua nhiều hơn số voucher hiện có trong cửa hàng',
        }
      },
    },
    'usage': {
      'path-expired': 'Đường dẫn xác nhận đã hết hạn',
      'path-not-exist': 'Đường dẫn xác nhận không tồn tại',
    }
  }
}
